import { actionTypes } from "./actionTypes";

const initialState = {
  invoices: [],
  loading: false,
  error: null,
};

export const providerErpInvoices = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROVIDER_ERP_INVOICES:
      return {
        ...state,
        invoices: action.data,
        loading: false,
        error: null,
      };
    case actionTypes.SET_PROVIDER_ERP_INVOICES_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case actionTypes.SET_PROVIDER_ERP_INVOICES_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

export default providerErpInvoices;
